export enum TimezoneEnum {
  UTC = "utc",

  /**
   * Africa
   */
  AFRICA_ABIDJAN = "africa_abidjan",
  AFRICA_ACCRA = "africa_accra",
  AFRICA_ADDIS_ABABA = "africa_addis_ababa",
  AFRICA_ALGIERS = "africa_algiers",
  AFRICA_ASMARA = "africa_asmara",
  AFRICA_BAMAKO = "africa_bamako",
  AFRICA_BANGUI = "africa_bangui",
  AFRICA_BANJUL = "africa_banjul",
  AFRICA_BISSAU = "africa_bissau",
  AFRICA_BLANTYRE = "africa_blantyre",
  AFRICA_BRAZZAVILLE = "africa_brazzaville",
  AFRICA_BUJUMBURA = "africa_bujumbura",
  AFRICA_CAIRO = "africa_cairo",
  AFRICA_CASABLANCA = "africa_casablanca",
  AFRICA_CEUTA = "africa_ceuta",
  AFRICA_CONAKRY = "africa_conakry",
  AFRICA_DAKAR = "africa_dakar",
  AFRICA_DAR_ES_SALAAM = "africa_dar_es_salaam",
  AFRICA_DJIBOUTI = "africa_djibouti",
  AFRICA_DOUALA = "africa_douala",
  AFRICA_EL_AAIUN = "africa_el_aaiun",
  AFRICA_FREETOWN = "africa_freetown",
  AFRICA_GABORONE = "africa_gaborone",
  AFRICA_HARARE = "africa_harare",
  AFRICA_JOHANNESBURG = "africa_johannesburg",
  AFRICA_JUBA = "africa_juba",
  AFRICA_KAMPALA = "africa_kampala",
  AFRICA_KHARTOUM = "africa_khartoum",
  AFRICA_KIGALI = "africa_kigali",
  AFRICA_KINSHASA = "africa_kinshasa",
  AFRICA_LAGOS = "africa_lagos",
  AFRICA_LIBREVILLE = "africa_libreville",
  AFRICA_LOME = "africa_lome",
  AFRICA_LUANDA = "africa_luanda",
  AFRICA_LUBUMBASHI = "africa_lubumbashi",
  AFRICA_LUSAKA = "africa_lusaka",
  AFRICA_MALABO = "africa_malabo",
  AFRICA_MAPUTO = "africa_maputo",
  AFRICA_MASERU = "africa_maseru",
  AFRICA_MBABANE = "africa_mbabane",
  AFRICA_MOGADISHU = "africa_mogadishu",
  AFRICA_MONROVIA = "africa_monrovia",
  AFRICA_NAIROBI = "africa_nairobi",
  AFRICA_NDJAMENA = "africa_ndjamena",
  AFRICA_NIAMEY = "africa_niamey",
  AFRICA_NOUAKCHOTT = "africa_nouakchott",
  AFRICA_OUAGADOUGOU = "africa_ouagadougou",
  AFRICA_PORTO_NOVO = "africa_porto_novo",
  AFRICA_SAO_TOME = "africa_sao_tome",
  AFRICA_TRIPOLI = "africa_tripoli",
  AFRICA_TUNIS = "africa_tunis",
  AFRICA_WINDHOEK = "africa_windhoek",

  /**
   * America
   */
  AMERICA_ADAK = "america_adak",
  AMERICA_ANCHORAGE = "america_anchorage",
  AMERICA_ANGUILLA = "america_anguilla",
  AMERICA_ANTIGUA = "america_antigua",
  AMERICA_ARAGUAINA = "america_araguaina",
  AMERICA_ARGENTINA_BUENOS_AIRES = "america_argentina_buenos_aires",
  AMERICA_ARGENTINA_CATAMARCA = "america_argentina_catamarca",
  AMERICA_ARGENTINA_CORDOBA = "america_argentina_cordoba",
  AMERICA_ARGENTINA_JUJUY = "america_argentina_jujuy",
  AMERICA_ARGENTINA_LA_RIOJA = "america_argentina_la_rioja",
  AMERICA_ARGENTINA_MENDOZA = "america_argentina_mendoza",
  AMERICA_ARGENTINA_RIO_GALLEGOS = "america_argentina_rio_gallegos",
  AMERICA_ARGENTINA_SALTA = "america_argentina_salta",
  AMERICA_ARGENTINA_SAN_JUAN = "america_argentina_san_juan",
  AMERICA_ARGENTINA_SAN_LUIS = "america_argentina_san_luis",
  AMERICA_ARGENTINA_TUCUMAN = "america_argentina_tucuman",
  AMERICA_ARGENTINA_USHUAIA = "america_argentina_ushuaia",
  AMERICA_ARUBA = "america_aruba",
  AMERICA_ASUNCION = "america_asuncion",
  AMERICA_ATIKOKAN = "america_atikokan",
  AMERICA_BAHIA = "america_bahia",
  AMERICA_BAHIA_BANDERAS = "america_bahia_banderas",
  AMERICA_BARBADOS = "america_barbados",
  AMERICA_BELEM = "america_belem",
  AMERICA_BELIZE = "america_belize",
  AMERICA_BLANC_SABLON = "america_blanc_sablon",
  AMERICA_BOA_VISTA = "america_boa_vista",
  AMERICA_BOGOTA = "america_bogota",
  AMERICA_BOISE = "america_boise",
  AMERICA_CAMBRIDGE_BAY = "america_cambridge_bay",
  AMERICA_CAMPO_GRANDE = "america_campo_grande",
  AMERICA_CANCUN = "america_cancun",
  AMERICA_CARACAS = "america_caracas",
  AMERICA_CAYENNE = "america_cayenne",
  AMERICA_CAYMAN = "america_cayman",
  AMERICA_CHICAGO = "america_chicago",
  AMERICA_CHIHUAHUA = "america_chihuahua",
  AMERICA_CIUDAD_JUAREZ = "america_ciudad_juarez",
  AMERICA_COSTA_RICA = "america_costa_rica",
  AMERICA_CRESTON = "america_creston",
  AMERICA_CUIABA = "america_cuiaba",
  AMERICA_CURACAO = "america_curacao",
  AMERICA_DANMARKSHAVN = "america_danmarkshavn",
  AMERICA_DAWSON = "america_dawson",
  AMERICA_DAWSON_CREEK = "america_dawson_creek",
  AMERICA_DENVER = "america_denver",
  AMERICA_DETROIT = "america_detroit",
  AMERICA_DOMINICA = "america_dominica",
  AMERICA_EDMONTON = "america_edmonton",
  AMERICA_EIRUNEPE = "america_eirunepe",
  AMERICA_EL_SALVADOR = "america_el_salvador",
  AMERICA_FORT_NELSON = "america_fort_nelson",
  AMERICA_FORTALEZA = "america_fortaleza",
  AMERICA_GLACE_BAY = "america_glace_bay",
  AMERICA_GOOSE_BAY = "america_goose_bay",
  AMERICA_GRAND_TURK = "america_grand_turk",
  AMERICA_GRENADA = "america_grenada",
  AMERICA_GUADELOUPE = "america_guadeloupe",
  AMERICA_GUATEMALA = "america_guatemala",
  AMERICA_GUAYAQUIL = "america_guayaquil",
  AMERICA_GUYANA = "america_guyana",
  AMERICA_HALIFAX = "america_halifax",
  AMERICA_HAVANA = "america_havana",
  AMERICA_HERMOSILLO = "america_hermosillo",
  AMERICA_INDIANA_INDIANAPOLIS = "america_indiana_indianapolis",
  AMERICA_INDIANA_KNOX = "america_indiana_knox",
  AMERICA_INDIANA_MARENGO = "america_indiana_marengo",
  AMERICA_INDIANA_PETERSBURG = "america_indiana_petersburg",
  AMERICA_INDIANA_TELL_CITY = "america_indiana_tell_city",
  AMERICA_INDIANA_VEVAY = "america_indiana_vevay",
  AMERICA_INDIANA_VINCENNES = "america_indiana_vincennes",
  AMERICA_INDIANA_WINAMAC = "america_indiana_winamac",
  AMERICA_INUVIK = "america_inuvik",
  AMERICA_IQALUIT = "america_iqaluit",
  AMERICA_JAMAICA = "america_jamaica",
  AMERICA_JUNEAU = "america_juneau",
  AMERICA_KENTUCKY_LOUISVILLE = "america_kentucky_louisville",
  AMERICA_KENTUCKY_MONTICELLO = "america_kentucky_monticello",
  AMERICA_KRALENDIJK = "america_kralendijk",
  AMERICA_LA_PAZ = "america_la_paz",
  AMERICA_LIMA = "america_lima",
  AMERICA_LOS_ANGELES = "america_los_angeles",
  AMERICA_LOWER_PRINCES = "america_lower_princes",
  AMERICA_MACEIO = "america_maceio",
  AMERICA_MANAGUA = "america_managua",
  AMERICA_MANAUS = "america_manaus",
  AMERICA_MARIGOT = "america_marigot",
  AMERICA_MARTINIQUE = "america_martinique",
  AMERICA_MATAMOROS = "america_matamoros",
  AMERICA_MAZATLAN = "america_mazatlan",
  AMERICA_MENOMINEE = "america_menominee",
  AMERICA_MERIDA = "america_merida",
  AMERICA_METLAKATLA = "america_metlakatla",
  AMERICA_MEXICO_CITY = "america_mexico_city",
  AMERICA_MIQUELON = "america_miquelon",
  AMERICA_MONCTON = "america_moncton",
  AMERICA_MONTERREY = "america_monterrey",
  AMERICA_MONTEVIDEO = "america_montevideo",
  AMERICA_MONTSERRAT = "america_montserrat",
  AMERICA_NASSAU = "america_nassau",
  AMERICA_NEW_YORK = "america_new_york",
  AMERICA_NOME = "america_nome",
  AMERICA_NORONHA = "america_noronha",
  AMERICA_NORTH_DAKOTA_BEULAH = "america_north_dakota_beulah",
  AMERICA_NORTH_DAKOTA_CENTER = "america_north_dakota_center",
  AMERICA_NORTH_DAKOTA_NEW_SALEM = "america_north_dakota_new_salem",
  AMERICA_NUUK = "america_nuuk",
  AMERICA_OJINAGA = "america_ojinaga",
  AMERICA_PANAMA = "america_panama",
  AMERICA_PARAMARIBO = "america_paramaribo",
  AMERICA_PHOENIX = "america_phoenix",
  AMERICA_PORT_AU_PRINCE = "america_port_au_prince",
  AMERICA_PORT_OF_SPAIN = "america_port_of_spain",
  AMERICA_PORTO_VELHO = "america_porto_velho",
  AMERICA_PUERTO_RICO = "america_puerto_rico",
  AMERICA_PUNTA_ARENAS = "america_punta_arenas",
  AMERICA_RANKIN_INLET = "america_rankin_inlet",
  AMERICA_RECIFE = "america_recife",
  AMERICA_REGINA = "america_regina",
  AMERICA_RESOLUTE = "america_resolute",
  AMERICA_RIO_BRANCO = "america_rio_branco",
  AMERICA_SANTAREM = "america_santarem",
  AMERICA_SANTIAGO = "america_santiago",
  AMERICA_SANTO_DOMINGO = "america_santo_domingo",
  AMERICA_SAO_PAULO = "america_sao_paulo",
  AMERICA_SCORESBYSUND = "america_scoresbysund",
  AMERICA_SITKA = "america_sitka",
  AMERICA_ST_BARTHELEMY = "america_st_barthelemy",
  AMERICA_ST_JOHNS = "america_st_johns",
  AMERICA_ST_KITTS = "america_st_kitts",
  AMERICA_ST_LUCIA = "america_st_lucia",
  AMERICA_ST_THOMAS = "america_st_thomas",
  AMERICA_ST_VINCENT = "america_st_vincent",
  AMERICA_SWIFT_CURRENT = "america_swift_current",
  AMERICA_TEGUCIGALPA = "america_tegucigalpa",
  AMERICA_THULE = "america_thule",
  AMERICA_TIJUANA = "america_tijuana",
  AMERICA_TORONTO = "america_toronto",
  AMERICA_TORTOLA = "america_tortola",
  AMERICA_VANCOUVER = "america_vancouver",
  AMERICA_WHITEHORSE = "america_whitehorse",
  AMERICA_WINNIPEG = "america_winnipeg",
  AMERICA_YAKUTAT = "america_yakutat",

  /**
   * Antarctica
   */
  ANTARCTICA_CASEY = "antarctica_casey",
  ANTARCTICA_DAVIS = "antarctica_davis",
  ANTARCTICA_DUMONTDURVILLE = "antarctica_dumontdurville",
  ANTARCTICA_MACQUARIE = "antarctica_macquarie",
  ANTARCTICA_MAWSON = "antarctica_mawson",
  ANTARCTICA_MCMURDO = "antarctica_mcmurdo",
  ANTARCTICA_PALMER = "antarctica_palmer",
  ANTARCTICA_ROTHERA = "antarctica_rothera",
  ANTARCTICA_SYOWA = "antarctica_syowa",
  ANTARCTICA_TROLL = "antarctica_troll",
  ANTARCTICA_VOSTOK = "antarctica_vostok",

  /**
   * Arctic
   */
  ARCTIC_LONGYEARBYEN = "arctic_longyearbyen",

  /**
   * Asia
   */
  ASIA_ADEN = "asia_aden",
  ASIA_ALMATY = "asia_almaty",
  ASIA_AMMAN = "asia_amman",
  ASIA_ANADYR = "asia_anadyr",
  ASIA_AQTAU = "asia_aqtau",
  ASIA_AQTOBE = "asia_aqtobe",
  ASIA_ASHGABAT = "asia_ashgabat",
  ASIA_ATYRAU = "asia_atyrau",
  ASIA_BAGHDAD = "asia_baghdad",
  ASIA_BAHRAIN = "asia_bahrain",
  ASIA_BAKU = "asia_baku",
  ASIA_BANGKOK = "asia_bangkok",
  ASIA_BARNAUL = "asia_barnaul",
  ASIA_BEIRUT = "asia_beirut",
  ASIA_BISHKEK = "asia_bishkek",
  ASIA_BRUNEI = "asia_brunei",
  ASIA_CHITA = "asia_chita",
  ASIA_CHOIBALSAN = "asia_choibalsan",
  ASIA_COLOMBO = "asia_colombo",
  ASIA_DAMASCUS = "asia_damascus",
  ASIA_DHAKA = "asia_dhaka",
  ASIA_DILI = "asia_dili",
  ASIA_DUBAI = "asia_dubai",
  ASIA_DUSHANBE = "asia_dushanbe",
  ASIA_FAMAGUSTA = "asia_famagusta",
  ASIA_GAZA = "asia_gaza",
  ASIA_HEBRON = "asia_hebron",
  ASIA_HO_CHI_MINH = "asia_ho_chi_minh",
  ASIA_HONG_KONG = "asia_hong_kong",
  ASIA_HOVD = "asia_hovd",
  ASIA_IRKUTSK = "asia_irkutsk",
  ASIA_JAKARTA = "asia_jakarta",
  ASIA_JAYAPURA = "asia_jayapura",
  ASIA_JERUSALEM = "asia_jerusalem",
  ASIA_KABUL = "asia_kabul",
  ASIA_KAMCHATKA = "asia_kamchatka",
  ASIA_KARACHI = "asia_karachi",
  ASIA_KATHMANDU = "asia_kathmandu",
  ASIA_KHANDYGA = "asia_khandyga",
  ASIA_KOLKATA = "asia_kolkata",
  ASIA_KRASNOYARSK = "asia_krasnoyarsk",
  ASIA_KUALA_LUMPUR = "asia_kuala_lumpur",
  ASIA_KUCHING = "asia_kuching",
  ASIA_KUWAIT = "asia_kuwait",
  ASIA_MACAU = "asia_macau",
  ASIA_MAGADAN = "asia_magadan",
  ASIA_MAKASSAR = "asia_makassar",
  ASIA_MANILA = "asia_manila",
  ASIA_MUSCAT = "asia_muscat",
  ASIA_NICOSIA = "asia_nicosia",
  ASIA_NOVOKUZNETSK = "asia_novokuznetsk",
  ASIA_NOVOSIBIRSK = "asia_novosibirsk",
  ASIA_OMSK = "asia_omsk",
  ASIA_ORAL = "asia_oral",
  ASIA_PHNOM_PENH = "asia_phnom_penh",
  ASIA_PONTIANAK = "asia_pontianak",
  ASIA_PYONGYANG = "asia_pyongyang",
  ASIA_QATAR = "asia_qatar",
  ASIA_QOSTANAY = "asia_qostanay",
  ASIA_QYZYLORDA = "asia_qyzylorda",
  ASIA_RIYADH = "asia_riyadh",
  ASIA_SAKHALIN = "asia_sakhalin",
  ASIA_SAMARKAND = "asia_samarkand",
  ASIA_SEOUL = "asia_seoul",
  ASIA_SHANGHAI = "asia_shanghai",
  ASIA_SINGAPORE = "asia_singapore",
  ASIA_SREDNEKOLYMSK = "asia_srednekolymsk",
  ASIA_TAIPEI = "asia_taipei",
  ASIA_TASHKENT = "asia_tashkent",
  ASIA_TBILISI = "asia_tbilisi",
  ASIA_TEHRAN = "asia_tehran",
  ASIA_THIMPHU = "asia_thimphu",
  ASIA_TOKYO = "asia_tokyo",
  ASIA_TOMSK = "asia_tomsk",
  ASIA_ULAANBAATAR = "asia_ulaanbaatar",
  ASIA_URUMQI = "asia_urumqi",
  ASIA_UST_NERA = "asia_ust_nera",
  ASIA_VIENTIANE = "asia_vientiane",
  ASIA_VLADIVOSTOK = "asia_vladivostok",
  ASIA_YAKUTSK = "asia_yakutsk",
  ASIA_YANGON = "asia_yangon",
  ASIA_YEKATERINBURG = "asia_yekaterinburg",
  ASIA_YEREVAN = "asia_yerevan",

  /**
   * Atlantic
   */
  ATLANTIC_AZORES = "atlantic_azores",
  ATLANTIC_BERMUDA = "atlantic_bermuda",
  ATLANTIC_CANARY = "atlantic_canary",
  ATLANTIC_CAPE_VERDE = "atlantic_cape_verde",
  ATLANTIC_FAROE = "atlantic_faroe",
  ATLANTIC_MADEIRA = "atlantic_madeira",
  ATLANTIC_REYKJAVIK = "atlantic_reykjavik",
  ATLANTIC_SOUTH_GEORGIA = "atlantic_south_georgia",
  ATLANTIC_ST_HELENA = "atlantic_st_helena",
  ATLANTIC_STANLEY = "atlantic_stanley",

  /**
   * Australia
   */
  AUSTRALIA_ADELAIDE = "australia_adelaide",
  AUSTRALIA_BRISBANE = "australia_brisbane",
  AUSTRALIA_BROKEN_HILL = "australia_broken_hill",
  AUSTRALIA_DARWIN = "australia_darwin",
  AUSTRALIA_EUCLA = "australia_eucla",
  AUSTRALIA_HOBART = "australia_hobart",
  AUSTRALIA_LINDEMAN = "australia_lindeman",
  AUSTRALIA_LORD_HOWE = "australia_lord_howe",
  AUSTRALIA_MELBOURNE = "australia_melbourne",
  AUSTRALIA_PERTH = "australia_perth",
  AUSTRALIA_SYDNEY = "australia_sydney",

  /**
   * Europe
   */
  EUROPE_AMSTERDAM = "europe_amsterdam",
  EUROPE_ANDORRA = "europe_andorra",
  EUROPE_ASTRAKHAN = "europe_astrakhan",
  EUROPE_ATHENS = "europe_athens",
  EUROPE_BELGRADE = "europe_belgrade",
  EUROPE_BERLIN = "europe_berlin",
  EUROPE_BRATISLAVA = "europe_bratislava",
  EUROPE_BRUSSELS = "europe_brussels",
  EUROPE_BUCHAREST = "europe_bucharest",
  EUROPE_BUDAPEST = "europe_budapest",
  EUROPE_BUSINGEN = "europe_busingen",
  EUROPE_CHISINAU = "europe_chisinau",
  EUROPE_COPENHAGEN = "europe_copenhagen",
  EUROPE_DUBLIN = "europe_dublin",
  EUROPE_GIBRALTAR = "europe_gibraltar",
  EUROPE_GUERNSEY = "europe_guernsey",
  EUROPE_HELSINKI = "europe_helsinki",
  EUROPE_ISLE_OF_MAN = "europe_isle_of_man",
  EUROPE_ISTANBUL = "europe_istanbul",
  EUROPE_JERSEY = "europe_jersey",
  EUROPE_KALININGRAD = "europe_kaliningrad",
  EUROPE_KIROV = "europe_kirov",
  EUROPE_KYIV = "europe_kyiv",
  EUROPE_LISBON = "europe_lisbon",
  EUROPE_LJUBLJANA = "europe_ljubljana",
  EUROPE_LONDON = "europe_london",
  EUROPE_LUXEMBOURG = "europe_luxembourg",
  EUROPE_MADRID = "europe_madrid",
  EUROPE_MALTA = "europe_malta",
  EUROPE_MARIEHAMN = "europe_mariehamn",
  EUROPE_MINSK = "europe_minsk",
  EUROPE_MONACO = "europe_monaco",
  EUROPE_MOSCOW = "europe_moscow",
  EUROPE_OSLO = "europe_oslo",
  EUROPE_PARIS = "europe_paris",
  EUROPE_PODGORICA = "europe_podgorica",
  EUROPE_PRAGUE = "europe_prague",
  EUROPE_RIGA = "europe_riga",
  EUROPE_ROME = "europe_rome",
  EUROPE_SAMARA = "europe_samara",
  EUROPE_SAN_MARINO = "europe_san_marino",
  EUROPE_SARAJEVO = "europe_sarajevo",
  EUROPE_SARATOV = "europe_saratov",
  EUROPE_SIMFEROPOL = "europe_simferopol",
  EUROPE_SKOPJE = "europe_skopje",
  EUROPE_SOFIA = "europe_sofia",
  EUROPE_STOCKHOLM = "europe_stockholm",
  EUROPE_TALLINN = "europe_tallinn",
  EUROPE_TIRANE = "europe_tirane",
  EUROPE_ULYANOVSK = "europe_ulyanovsk",
  EUROPE_VADUZ = "europe_vaduz",
  EUROPE_VATICAN = "europe_vatican",
  EUROPE_VIENNA = "europe_vienna",
  EUROPE_VILNIUS = "europe_vilnius",
  EUROPE_VOLGOGRAD = "europe_volgograd",
  EUROPE_WARSAW = "europe_warsaw",
  EUROPE_ZAGREB = "europe_zagreb",
  EUROPE_ZURICH = "europe_zurich",

  /**
   * Indian
   */
  INDIAN_ANTANANARIVO = "indian_antananarivo",
  INDIAN_CHAGOS = "indian_chagos",
  INDIAN_CHRISTMAS = "indian_christmas",
  INDIAN_COCOS = "indian_cocos",
  INDIAN_COMORO = "indian_comoro",
  INDIAN_KERGUELEN = "indian_kerguelen",
  INDIAN_MAHE = "indian_mahe",
  INDIAN_MALDIVES = "indian_maldives",
  INDIAN_MAURITIUS = "indian_mauritius",
  INDIAN_MAYOTTE = "indian_mayotte",
  INDIAN_REUNION = "indian_reunion",

  /**
   * Pacific
   */
  PACIFIC_APIA = "pacific_apia",
  PACIFIC_AUCKLAND = "pacific_auckland",
  PACIFIC_BOUGAINVILLE = "pacific_bougainville",
  PACIFIC_CHATHAM = "pacific_chatham",
  PACIFIC_CHUUK = "pacific_chuuk",
  PACIFIC_EASTER = "pacific_easter",
  PACIFIC_EFATE = "pacific_efate",
  PACIFIC_FAKAOFO = "pacific_fakaofo",
  PACIFIC_FIJI = "pacific_fiji",
  PACIFIC_FUNAFUTI = "pacific_funafuti",
  PACIFIC_GALAPAGOS = "pacific_galapagos",
  PACIFIC_GAMBIER = "pacific_gambier",
  PACIFIC_GUADALCANAL = "pacific_guadalcanal",
  PACIFIC_GUAM = "pacific_guam",
  PACIFIC_HONOLULU = "pacific_honolulu",
  PACIFIC_KANTON = "pacific_kanton",
  PACIFIC_KIRITIMATI = "pacific_kiritimati",
  PACIFIC_KOSRAE = "pacific_kosrae",
  PACIFIC_KWAJALEIN = "pacific_kwajalein",
  PACIFIC_MAJURO = "pacific_majuro",
  PACIFIC_MARQUESAS = "pacific_marquesas",
  PACIFIC_MIDWAY = "pacific_midway",
  PACIFIC_NAURU = "pacific_nauru",
  PACIFIC_NIUE = "pacific_niue",
  PACIFIC_NORFOLK = "pacific_norfolk",
  PACIFIC_NOUMEA = "pacific_noumea",
  PACIFIC_PAGO_PAGO = "pacific_pago_pago",
  PACIFIC_PALAU = "pacific_palau",
  PACIFIC_PITCAIRN = "pacific_pitcairn",
  PACIFIC_POHNPEI = "pacific_pohnpei",
  PACIFIC_PORT_MORESBY = "pacific_port_moresby",
  PACIFIC_RAROTONGA = "pacific_rarotonga",
  PACIFIC_SAIPAN = "pacific_saipan",
  PACIFIC_TAHITI = "pacific_tahiti",
  PACIFIC_TARAWA = "pacific_tarawa",
  PACIFIC_TONGATAPU = "pacific_tongatapu",
  PACIFIC_WAKE = "pacific_wake",
  PACIFIC_WALLIS = "pacific_wallis",
}
